import React from 'react';
import StaticOfferContainer from 'partial/OfferManager/StaticOfferContainer';
import { StandardHomeLoanOfferRedesign } from 'components/Offers/StandardHomeLoanOfferRedesign';

const HomeLoanOfferView = props => {
  const { hlOffers } = props;
  return (
    <StaticOfferContainer
      offerMetadataList={hlOffers?.slice(0, 1)}
      homeLoanTemplate={StandardHomeLoanOfferRedesign}
      pagePosition={props.pagePosition}
      modulePosition={props.modulePosition}
      eventHandler={props.eventHandler}
    />
  );
};

export default HomeLoanOfferView;
